import { HttpParams } from '@angular/common/http'
import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { BaseComponent, Services } from '../../shared'

@Component({
    templateUrl: './attendee.component.html',
    standalone: true,
})
export class AttendeeComponent extends BaseComponent implements OnInit {
    message?: string
    meetingId?: string | null

    constructor(
        services: Services,
        private route: ActivatedRoute,
    ) {
        super()
    }

    ngOnInit() {
        this.meetingId = this.route.snapshot.queryParamMap.get('id')
    }

    register() {
        if (!this.meetingId) {
            this.message = 'There was an issue finding the meeting.'
            return
        }
        this.message = 'Loading...'
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get('/api/SafetyMeeting/AddAttendee', new HttpParams().set('meetingId', this.meetingId)),
                )
                .subscribe(
                    successResult => {
                        this.message = 'You have been registered for the meeting.'
                    },
                    errorResult => {
                        this.message = 'Registration failed.'
                    },
                ),
        )
    }

    decline() {
        this.message = 'You have declined the meeting.'
    }
}
